import { render } from "./ListMethods.vue?vue&type=template&id=6f08e9c8&lang=pug"
import script from "./ListMethods.vue?vue&type=script&lang=js"
export * from "./ListMethods.vue?vue&type=script&lang=js"

import "./ListMethods.vue?vue&type=style&index=0&id=6f08e9c8&lang=scss"

import exportComponent from "/builds/fenix/ais-abr/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__